import { render } from "./SortTable.vue?vue&type=template&id=50353e2c"
import script from "./SortTable.vue?vue&type=script&lang=js"
export * from "./SortTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__